export const Members = {
    BOUCHRA: 'Bouchra Williot',
    KAREN: 'Karen McTavish',
};
